module.exports = __webpack_public_path__ + "static/media/img-04.a21c793e.jpg";